import { getLanguageIso6391, magicConfig } from '@gig/magic-common';
import { magic } from '@gig/magic-sdk';
import { WALLET_CONFIG_QUERY } from '@gig/magic-messages';
import { getRedirectOutputForm } from './get-redirect-output-form.js';
import { getEncryptedCvc, injectEncryptionScript } from './encryption.js';
import { WalletView } from '@gig/magic-wallet-types';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class PaymentService {
  constructor() {
    this.initialised = false;
  }
  getCreditCards() {
    return __async(this, null, function* () {
      yield this._initialiseService();
      try {
        const url = `${this.paymentUrl}/api/user/payment/method/${this.merchant}/${this.userId}?sessionId=${this.igcToken}&method=deposit`;
        const cardsResponse = yield fetch(url).then((response) => response.json());
        return cardsResponse.methods.reduce((acc, method) => acc.concat(method.accounts.map((account) => __spreadProps(__spreadValues({}, account), {
          limit: {
            max: parseFloat(method.limit.max),
            min: parseFloat(method.limit.min)
          },
          providerType: method.providerType.toLowerCase()
        }))), []).filter((account) => account.type === "creditcard" && account.status === "ACTIVE").map((_a) => {
          var _b = _a, { accountId, maskedAccount } = _b, card = __objRest(_b, ["accountId", "maskedAccount"]);
          return __spreadProps(__spreadValues({}, card), {
            accountId,
            maskedAccount,
            name: maskedAccount.slice(-6),
            value: accountId
          });
        });
      } catch (e) {
        console.error("Could not fetch credit cards", e);
        return [];
      }
    });
  }
  quickDeposit(params) {
    return __async(this, null, function* () {
      yield this._initialiseService();
      const { amount, card, cvv, device } = params;
      const attributes = {
        type: "QuickDeposit",
        bonusCode: "",
        channel: device
      };
      const url = `${this.paymentUrl}/api/${card.providerType}/deposit/process?locale=${this.locale}`;
      try {
        const depositResponse = yield fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(__spreadValues({
            userId: this.userId,
            merchantId: this.merchant,
            sessionId: this.igcToken,
            accountId: card.value,
            amount,
            encCvv: getEncryptedCvc(cvv),
            attributes
          }, card.service && { service: card.service }))
        }).then((response) => response.json());
        const { redirectOutput } = depositResponse;
        if (redirectOutput && !redirectOutput.html) {
          redirectOutput.form = getRedirectOutputForm(redirectOutput);
        }
        return depositResponse;
      } catch (e) {
        console.error("Could not deposit amount", e);
        const result = {
          success: false,
          txRefId: "",
          txState: ""
        };
        return result;
      }
    });
  }
  _initialiseService() {
    return __async(this, null, function* () {
      if (this.initialisationPromise) {
        return this.initialisationPromise;
      }
      this.initialisationPromise = (() => __async(this, null, function* () {
        var _a;
        const user = magic.session.getUser();
        if (user) {
          this.locale = `${getLanguageIso6391(magicConfig.language)}_${user.country}`;
          this.igcToken = user.igcToken;
          this.userId = user.userId;
          if (!this.initialised) {
            this.paymentUrl = (_a = magicConfig.wallet) == null ? void 0 : _a.paymentUrl;
            const config = yield window.queryBus.query(WALLET_CONFIG_QUERY, {
              view: WalletView.DEPOSIT
            });
            this.merchant = config.devcodeMerchantId;
            yield injectEncryptionScript(config.environment, config.devcodeMerchantId);
            this.initialised = true;
          }
        }
      }))();
      return this.initialisationPromise;
    });
  }
}
const paymentService = new PaymentService();

export { PaymentService, paymentService };
